var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogleAlert(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5727 1.50034C5.55617 5.53461 2.14784 12.3513 0.286891 16.0732C-0.134024 16.9138 -0.0893989 17.9136 0.405086 18.7132C0.899571 19.5129 1.77396 20.0001 2.71349 20.0001H17.2863C18.227 20.0001 19.1002 19.5129 19.5947 18.7132C20.0892 17.9136 20.1338 16.9138 19.7141 16.0732C17.8532 12.3513 14.4448 5.53461 12.4271 1.50034C11.9676 0.581322 11.0281 0 10.0005 0C8.97294 0 8.03221 0.581322 7.5727 1.50034Z",
    fill: "#FFA500"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.01562 6.97095V13.0097C9.01562 13.509 9.42086 13.9142 9.92017 13.9142C10.4183 13.9142 10.8247 13.509 10.8247 13.0097V6.97095C10.8247 6.47164 10.4183 6.06641 9.92017 6.06641C9.42086 6.06641 9.01562 6.47164 9.01562 6.97095Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.92017 16.6177C10.4197 16.6177 10.8247 16.2127 10.8247 15.7131C10.8247 15.2136 10.4197 14.8086 9.92017 14.8086C9.4206 14.8086 9.01562 15.2136 9.01562 15.7131C9.01562 16.2127 9.4206 16.6177 9.92017 16.6177Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleAlert);
export default __webpack_public_path__ + "static/media/googleAlert.1b4fd0fb9a6ddd1530e4bfe256ac30b2.svg";
export { ForwardRef as ReactComponent };